import { Component, OnInit } from '@angular/core';
import { Particionamento } from '../particionamento.model';
import { MensagemService, ProgressoService, Restricao, RestricaoOperador, Restricoes } from 'maestro-ng';
import { ParticionamentoService } from '../particionamento.service';
import { DataSourceRouted } from '../../util/data-source-routed';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-particionamento-lista',
  templateUrl: './particionamento-lista.component.html',
  styleUrls: ['./particionamento-lista.component.css'],
})
export class ParticionamentoListaComponent implements OnInit {
  public ds: DataSourceRouted<Particionamento, number>;

  constructor(
    private service: ParticionamentoService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.ds = new DataSourceRouted<Particionamento, number>(
      'administracao-particionamento',
      (c) => this.service.recuperarPaginado(c),
      this.mensagemService,
      this.progressoService,
      this.route,
      this.router,
      15,
      new Restricoes([new Restricao<string>({ atributo: 'tabela', operador: RestricaoOperador.CONTAINS })])
    );
  }

  ngOnInit(): void {}

  public gerenciarParticionamentoDaTabela(particionamento: Particionamento): void {
    this.progressoService.modal();
    this.service
      .gerenciarParticionamentoTabela(particionamento)
      .then(() => {
        this.progressoService.fechar();
        this.mensagemService.addSucesso('Sucesso', 'Tabela particionada com sucesso!');
        this.ds.atualizar();
      })
      .catch((response) => {
        this.progressoService.fechar();
        this.mensagemService.addErro(
          'Erro',
          'Erro ao realizar o processamento da mensagem id: ' + particionamento.tabela + '. Error: ' + response.error
        );
      });
  }

  public gerenciarParticionamentos(): void {
    this.progressoService.modal();
    this.service
      .gerenciarParticionamento()
      .then(() => {
        this.progressoService.fechar();
        this.mensagemService.addSucesso('Sucesso', 'Particionamento realizado com sucesso!');
        this.ds.atualizar();
      })
      .catch((response) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro', response.error);
      });
  }

  public extrairInformacoesParticoes(
    dados: string
  ): Array<{ tabela: string; de: string; ate: string; quantidadeLinhas: string }> {
    const particoes = dados.split('__');
    const result = particoes
      .filter((particao) => particao.trim().length > 0)
      .map((particao) => {
        const [tabelaParte, restante] = particao.split(':');
        const tabela = tabelaParte.trim();
        const [faixa, linhas] = restante.split('(');
        const [de, ate] = faixa
          .trim()
          .split('->')
          .map((item) => item.trim());
        const quantidadeLinhas = linhas.replace('linhas)', '').trim();
        return {
          tabela,
          de,
          ate,
          quantidadeLinhas,
        };
      });
    return result;
  }
}
